import A11yDialog from 'a11y-dialog';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import BaseView from '../../../js/base-view';

const FORM_SELECTOR = '.modal__form';
const COOKIE_WOOCOMMERCE_MULTICURRENCY = 'woocommerce_multicurrency_forced_currency';
const COOKIE_EDITION = 'country_edition';
const COOKIE_MODAL_SHOWN = 'supt-currency_edition-modal-shown';
const COOKIE_CURRENCY_WORLD = 'supt-currency-world';

const DEFAULT_CURRENCY = 'CHF';
const DEFAULT_EDITION = 'international';
const WORLD_CURRENCY_VALUE = 'world';

export default class Modal extends BaseView {
	init() {
		this.dialog = new A11yDialog(this.el, this.el.parentElement.querySelectorAll('*:not(.modal):not([class*="cookie-law"])'));

		this.el.style.display = null;

		this.refs = {
			overlay: this.el.querySelector('.modal__overlay'),
			content: this.el.querySelector('.modal__inner'),
			options: Array.from(this.el.querySelectorAll('input[type=radio]')),
		};

		this.state = {
			cookies: this.getInitialCookieState(),
			reloadUrl: window.location.href,
			shouldReloadPage: false,
		};

		// clicking the backdrop of the native dialog is not working on chrome
		// so we listen for the click event
		if (this.dialog.useDialog) {
			this.clickHandler = this.handleClick.bind(this);
			this.on('click', this.clickHandler);
		}
		else {
			// also remove hidden class from the alternative overlay fallback
			this.refs.overlay.classList.remove('is-hidden');
			this.bindOverlayClick();
		}

		this.dialog.on('show', this.onShow.bind(this));
		this.dialog.on('hide', this.onHide.bind(this));
		this.on('submit', FORM_SELECTOR, this.onSubmit.bind(this));

		/**
		 * Disable modal on first visit
		 * @see https://gitlab.com/superhuit/alliance-presse-multisite/-/issues/379
		 */
		// if (! this.getCookie(COOKIE_MODAL_SHOWN)) {
		// 	this.dialog.show();
		// 	this.setCookie(COOKIE_MODAL_SHOWN, true);
		// }
	}

	getInitialCookieState() {
		const currency = this.getCookie(COOKIE_WOOCOMMERCE_MULTICURRENCY, DEFAULT_CURRENCY);
		const worldCurrency = (this.getCookie(COOKIE_CURRENCY_WORLD, false) === 'true');
		return {
			[ `${ COOKIE_WOOCOMMERCE_MULTICURRENCY }` ]: (worldCurrency ? WORLD_CURRENCY_VALUE : currency),
			[ `${ COOKIE_EDITION }` ]: this.getCookie(COOKIE_EDITION, DEFAULT_EDITION),
		};
	}

	// #region Cookies getter and setter
	getCookie(name, dft = undefined) {
		const value = window.Cookies.get(name);
		return (typeof value === 'undefined' ? dft : value);
	}

	// TODO find why Cookie.set() does not work
	setCookie(name, value, expiryDays = 365, domain = null, path = '/', secure = false) {
		/* eslint-disable no-param-reassign */
		const exdate = new Date();
		exdate.setHours(exdate.getHours() + ((typeof expiryDays !== 'number' ? 365 : expiryDays) * 24));

		if (!domain && window.supt && window.supt.cookie_domain) domain = window.supt.cookie_domain;
		document.cookie = `${ name }=${ value };expires=${ exdate.toUTCString() };path=${ path || '/' }${ domain ? `;domain=${ domain }` : '' }${ secure ? ';secure' : '' };sameSite=Strict`;
	}
	// #endregion

	getCheckedOptions() {
		const checkedOptions = {};
		this.refs.options
			.filter((option) => option.checked)
			.forEach((option) => {
				checkedOptions[ option.name ] = option;
				if (option.dataset.link) {
					this.state.reloadUrl = option.dataset.link;
				}
			});
		return checkedOptions;
	}

	handleChoicesChanged() {
		const checkedOptions = this.getCheckedOptions();
		for (const key in checkedOptions) {
			// eslint-disable-next-line no-prototype-builtins
			if (checkedOptions.hasOwnProperty(key)) {
				const opt = checkedOptions[ key ];
				const { value } = opt;

				if (this.state.cookies[ key ] && this.state.cookies[ key ] !== value) {
					const newState = value;
					let newValue = value;

					if (key === COOKIE_WOOCOMMERCE_MULTICURRENCY) {
						newValue = opt.dataset.currency;
						this.setCookie(COOKIE_CURRENCY_WORLD, (value === WORLD_CURRENCY_VALUE));
					}

					this.setCookie(key, newValue);
					this.state.cookies[ key ] = newState;
					this.state.shouldReloadPage = true;
				}
			}
		}

		this.dialog.hide();
		this.handlePageReload();
	}

	handlePageReload() {
		if (this.state.shouldReloadPage) {
			window.location.assign(this.state.reloadUrl);
		}
	}

	handleClick(event) {
		if (event.target.classList.contains('modal__dialog')) {
			this.dialog.hide();
		}
	}

	bindOverlayClick() {
		this.hideHandler = this.hideOverlay.bind(this);
		this.on('click', '.modal__dialog-close', this.hideHandler, false);
	}

	hideOverlay() {
		this.refs.overlay.classList.add('is-hidden');
	}

	onShow() {
		disableBodyScroll(this.refs.content);
		this.refs.overlay.classList.remove('is-hidden');
	}

	onHide() {
		enableBodyScroll(this.refs.content);
	}

	onSubmit(event) {
		event.preventDefault();
		this.handleChoicesChanged();
	}

	destroy() {
		this.dialog.destroy();
		super.destroy();
	}
}
